/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { PageNotification } from '@coursera/cds-core';

import { TeamsContext } from 'bundles/teams-v2/components/TeamsContainer';

import _t from 'i18n!nls/teams-v2';

const styles = {
  wrapper: css`
    margin: 20px auto;
  `,
};

export const DISCRETIONARY_DISCOUNT_EXPIRED = 'DISCRETIONARY_DISCOUNT_EXPIRED' as const;

export type CheckoutWarning = 'DISCRETIONARY_DISCOUNT_EXPIRED' | undefined;

export type CheckoutWarnings = {
  checkoutWarning?: CheckoutWarning;
};

const TeamsCheckoutWarnings: React.FC = () => {
  const { checkoutWarning } = useContext(TeamsContext);

  if (checkoutWarning === 'DISCRETIONARY_DISCOUNT_EXPIRED') {
    return (
      <div css={styles.wrapper}>
        <PageNotification severity="error">
          {_t('Your offer has expired. Reach out to your sales representative for more information.')}
        </PageNotification>
      </div>
    );
  }

  return null;
};

export default TeamsCheckoutWarnings;
